import toast from 'react-hot-toast';
import { api } from '../../services/api';

// Server-built workbook downloads. The server owns the list's filter and sort,
// so the file is the list on screen, every page of it, not a client re-build
// that could disagree with the totals.
export async function downloadXlsx(url, params, fileName) {
  try {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')).toString();
    const blob = await api.getBlob(`${url}${qs ? `?${qs}` : ''}`);
    const href = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href;
    a.download = fileName;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(href);
  } catch (e) {
    toast.error(e.message || 'Export failed.');
  }
}
